<template>
  <div class="award-mortgage-business-card">
    <el-form ref="mktSalesCardForm" :model="mktSalesCardForm" label-width="80px" label-position="top">
      <el-form-item label="Name">
        <el-input v-model="mktSalesCardForm.Name"></el-input>
      </el-form-item>

      <el-form-item label="Title">
        <el-select v-model="mktSalesCardForm.Title" placeholder="Select Title">
          <el-option
            v-for="item in mktSalesCardForm.titles"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Phone Number">
        <el-input v-model="mktSalesCardForm.phoneNumber" @input="formatPhoneNumber"></el-input>
      </el-form-item>

      <el-form-item label="Branch Name">
        <el-input v-model="mktSalesCardForm.branch_name"></el-input>
      </el-form-item>

      <el-form-item label="Address">
        <el-input v-model="mktSalesCardForm.address"></el-input>
      </el-form-item>

      <el-form-item label="Profile Photo">
        <div style="display: flex; align-items: center; gap: 10px;">
          <el-upload
            class="uploader"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleImage1Change"
          >
            <img v-if="mktSalesCardForm.image1" :src="mktSalesCardForm.image1" class="image">
            <i v-else class="el-icon-plus uploader-icon"></i>
          </el-upload>
          <el-button
            v-if="mktSalesCardForm.image1"
            type="primary"
            size="small"
            @click="removeBackground"
            :loading="isRemovingBg"
          >
            Remove Background
          </el-button>
        </div>
        <div class="el-form-item__tip" style="line-height: 1.2; margin-top: 4px;">
          Please upload a professional-style upper-body portrait. The file size must not exceed 2MB.
        </div>
      </el-form-item>

      <el-form-item label="QR Code">
        <el-upload
          class="uploader"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleImage2Change"
        >
          <img v-if="mktSalesCardForm.image2" :src="mktSalesCardForm.image2" class="image">
          <i v-else class="el-icon-plus uploader-icon"></i>
        </el-upload>
        <div class="el-form-item__tip" style="line-height: 1.2; margin-top: 4px;">
          Please upload the black version of the QR code. The file size must not exceed 2MB.
        </div>
      </el-form-item>
    </el-form>

    <image-cropper-dialog
      v-model="cropperDialogVisible"
      :img="cropperImg"
      :autoCropWidth="250"
      :autoCropHeight="350"
      @crop-done="handleCropDone"
      @crop-cancel="handleCropCancel"
    >
    </image-cropper-dialog>

    <i class="fas fa-arrow-down" style="font-size: 35px; color: #b8b8b8"></i>

    <div id="cutSection5" style="display: flex; flex-direction: column; align-items: center;">
      <div id="pdf-content-wrapper" style="width: 600px; background-color: #ffffff;">
        <div id="showSectionWrapper" style="font-family: Aptos; width: 600px; position: relative;">
          <div style="position: relative; width: 100%;">
            <div style="position: absolute; bottom: 0px; right: 0; width: auto; height: auto; z-index: 8;">
              <img v-if="mktSalesCardForm.image1" :src="mktSalesCardForm.image1" style="position: absolute; width: 250px; height: 350px;
                    object-fit: cover; z-index: 8; bottom: 5px; right: 25px;">

              <img src="/mkt_business_card/right_pattern.png" style="position: absolute; width: 320px; height: auto;
                    z-index: 9; bottom: 0; right: 0;">

              <img v-if="mktSalesCardForm.image2" :src="mktSalesCardForm.image2" style="position: absolute; width: 85px; height: 85px;
                    object-fit: cover; z-index: 10; bottom: 15px; right: 25px;">
            </div>

            <img src="/mkt_business_card/background.png" style="width: 100%; display: block;">

            <div id="showSection"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; padding: 20px; color: #666; font-size: 14px; box-sizing: border-box;">
              <img src="/mkt_business_card/logo.png"
                style="position: absolute; top: 20px; left: 20px; height: 50px; z-index: 10; transform: scale(0.85); transform-origin: top left;">

              <div style="position: relative; z-index: 8; padding-top: 60px;">
                <div style="display: flex; align-items: baseline; margin-bottom: 30px;">
                  <span
                    style="font-family: 'Avalon' ; font-size: 28px; color: #EE8200; font-weight: 700; margin-right: 15px;">
                    {{ mktSalesCardForm.Name }}
                  </span>
                  <span style="font-size: 16px; color: #585656;">{{ mktSalesCardForm.Title }}</span>
                </div>

                <div
                  style="display: flex; flex-direction: column; margin-bottom: 20px; position: relative; height: 220px; max-width: 300px;">
                  <div
                    style="font-size: 18px; font-family: 'Avalon'; color: #585656; position: relative; top: -20px;">
                    <span v-if="mktSalesCardForm.branch_name" style="font-weight: bold;">{{
                      mktSalesCardForm.branch_name }}|</span>
                    <span>{{ mktSalesCardForm.address }}</span>
                  </div>

                  <div style="position: absolute; top: 60px; left: 0;
                width: 200px; height: 200px; z-index: 9;
                transform: scale(1.3); transform-origin: top left;
                overflow: visible;">
                    <img src="/mkt_business_card/icon_web_phone.png"
                      style="width: 14px; height: auto; margin-top: 40px;">

                    <div style="position: absolute; top: 18%; left: 20px; width: 100%; text-align: left; z-index: 9;">
                      <span style="color: #585656; text-shadow: 0 0 2px #ffffff;
font-size: 12px;font-family: 'Avalon' ;">{{ mktSalesCardForm.phoneNumber }}</span>
                    </div>
                    <div
                      style=" position: absolute; top: 27.6%; left: 20px; width: 100%; text-align: left; z-index: 9;">
                      <span style="color: #585656; text-shadow: 0 0 2px #ffffff;
font-size: 12px; font-family: 'Avalon' ;">{{ mktTurnNameToEmailName }}@awardmortgage.com.au</span>
                    </div>
                    <div
                      style="position: absolute; top: 37.3%; left: 20px; width: 100%; text-align: left; z-index: 9;">
                      <span style="color: #585656; text-shadow: 0 0 2px #ffffff;
font-size: 12px; font-family: 'Avalon' ;;">www.awardmortgage.com.au</span>
                    </div>
                    <div
                      style="position: absolute; top: 47.3%; left: 20px; width: 220px; z-index: 11; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      <span
                        style="color: #585656; text-shadow: 0 0 2px #ffffff; font-size: 12px; font-family: 'Avalon';">Australian
                        Credit Licence No. {{ mktSalesCardForm.acl_number }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="pdf-footer-wrapper" style="width: 600px; background-color: #ffffff;">
        <img src="/mkt_business_card/footer.png" style="width: 600px; display: block;">
      </div>

      <div>
        <span>
          If you encounter any other problems or new requirements during the business card production process,
          please contact MKT
        </span>
      </div>

      <el-button
        class="download-pdf-button"
        @click="generateHighQualityPDF"
        style="width: 300px; font-size: 20px; margin-top: 20px;"
      >
        Download Business Card
      </el-button>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';
import axios from 'axios';
import { Base64 } from 'js-base64';
import ImageCropperDialog from '@/components/ImageCropperDialog.vue';

export default {
  name: 'AwardMortgageBusinessCard',
  components: {
    ImageCropperDialog,
  },
  data() {
    return {
      mktSalesCardForm: {
        Name: 'Aaaa Aaaa',
        Title: 'Lending Manager',
        phoneNumber: '0488 888 888',
        acl_number: '387443',
        branch_name: 'Sydney Branch',
        address: 'Level 3, 370 Pitt Street',
        email_name: '',
        image1: '',
        image2: '',
        website: 'www.awardmortgage.com.au',
        titles: [
          {
            label: 'Lending Consultant',
            value: 'Lending Consultant',
          },
          {
            label: 'Lending Manager',
            value: 'Lending Manager',
          },
          {
            label: 'Senior Lending Manager',
            value: 'Senior Lending Manager',
          },
        ],
      },
      isRemovingBg: false,
      cropperDialogVisible: false,
      cropperImg: '',
    };
  },
  computed: {
    addressLines() {
      const address = this.mktSalesCardForm.address;
      if (!address) {
        return [];
      }

      const searchTerm = 'street';
      const streetIndex = address.toLowerCase().lastIndexOf(searchTerm);

      if (streetIndex !== -1) {
        let splitAfterIndex = streetIndex + searchTerm.length;

        if (address.charAt(splitAfterIndex) === ',') {
          splitAfterIndex++;
        }

        const line1 = address.substring(0, splitAfterIndex);
        const line2 = address.substring(splitAfterIndex).trim();

        return line2 ? [line1, line2] : [line1];
      }

      return [address];
    },
    mktTurnNameToEmailName() {
      const name = this.mktSalesCardForm.Name;
      return name.replace(/\s+/g, '').toLowerCase();
    },
  },
  methods: {
    formatPhoneNumber(value) {
      if (!value) {
        this.mktSalesCardForm.phoneNumber = '';
        return;
      }

      let val = value.replace(/\D/g, '');
      val = val.substring(0, 10);

      let formatted = val;
      if (val.length > 4 && val.length <= 7) {
        formatted = `${val.slice(0, 4)} ${val.slice(4)}`;
      } else if (val.length > 7) {
        formatted = `${val.slice(0, 4)} ${val.slice(4, 7)} ${val.slice(7)}`;
      }

      this.mktSalesCardForm.phoneNumber = formatted;
    },

    async removeBackground() {
      if (!this.mktSalesCardForm.image1) {
        this.$message.warning('please upload Person Image');
        return;
      }

      this.isRemovingBg = true;
      this.$message.info('Removing background... Please wait...');

      try {
        let imageSrc = this.mktSalesCardForm.image1;

        if (imageSrc.startsWith('http')) {
          const response = await axios.get(imageSrc, { responseType: 'arraybuffer' });
          const base64 = Base64.fromUint8Array(new Uint8Array(response.data));
          imageSrc = `data:${response.headers['content-type']};base64,${base64}`;
        }

        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageSrc;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const selfieSegmentation = new SelfieSegmentation({
          locateFile: (file) => {
            return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
          },
        });

        selfieSegmentation.setOptions({
          modelSelection: 0,
        });

        selfieSegmentation.onResults((results) => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';

          canvas.width = results.image.width;
          canvas.height = results.image.height;

          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(results.segmentationMask, 0, 0, canvas.width, canvas.height);

          ctx.globalCompositeOperation = 'source-in';
          ctx.drawImage(results.image, 0, 0, canvas.width, canvas.height);
          ctx.globalCompositeOperation = 'source-over';

          const transparentBase64 = canvas.toDataURL('image/png');

          this.$set(this.mktSalesCardForm, 'image1', transparentBase64);
          this.$message.success('Background removed successfully!');

          selfieSegmentation.close();
          this.isRemovingBg = false;
        });

        await selfieSegmentation.send({ image: img });
      } catch (error) {
        console.error('Background removal failed', error);
        this.$message.error('Background removal failed. Please try again.');
        this.isRemovingBg = false;
      }
    },

    async generateHighQualityPDF() {
      const pdfWrapper = document.getElementById('pdf-content-wrapper');
      const footerWrapper = document.getElementById('pdf-footer-wrapper');
      if (!pdfWrapper || !footerWrapper) {
        this.$message.error('Unfinished template detected.');
        return;
      }

      this.$message.info('Generating high-quality PDF...');

      await this.$nextTick();
      await document.fonts.ready;

      try {
        const canvasOptions = {
          scale: 8,
          useCORS: true,
          allowTaint: true,
          imageTimeout: 0,
          removeContainer: true,
          backgroundColor: '#ffffff',
        };

        const cardCanvas = await html2canvas(pdfWrapper, canvasOptions);
        const footerCanvas = await html2canvas(footerWrapper, canvasOptions);

        const cardImage = cardCanvas.toDataURL('image/jpeg', 0.98);
        const footerImage = footerCanvas.toDataURL('image/jpeg', 0.98);

        const cardWidthPx = cardCanvas.width;
        const cardHeightPx = cardCanvas.height;
        const footerWidthPx = footerCanvas.width;
        const footerHeightPx = footerCanvas.height;

        const scaleFactor = 90 / 600;

        const originalHtmlWidth = cardWidthPx / 8;
        const originalHtmlHeight = cardHeightPx / 8;

        const cardWidthMm = originalHtmlWidth * scaleFactor;
        const cardHeightMm = originalHtmlHeight * scaleFactor;

        const originalFooterWidth = footerWidthPx / 8;
        const originalFooterHeight = footerHeightPx / 8;

        const footerWidthMm = originalFooterWidth * scaleFactor;
        const footerHeightMm = originalFooterHeight * scaleFactor;

        const pdf = new jsPDF({
          orientation: cardWidthMm > cardHeightMm ? 'landscape' : 'portrait',
          unit: 'mm',
          format: [cardWidthMm, cardHeightMm],
        });

        pdf.addImage(cardImage, 'JPEG', 0, 0, cardWidthMm, cardHeightMm);

        pdf.addPage([footerWidthMm, footerHeightMm], footerWidthMm > footerHeightMm ? 'landscape' : 'portrait');
        pdf.addImage(footerImage, 'JPEG', 0, 0, footerWidthMm, footerHeightMm);

        const filename = `MKT_Sales_Card_${this.mktSalesCardForm.Name.replace(/\s+/g, '_')}_${new Date().toISOString().slice(0, 10)}.pdf`;
        pdf.save(filename);

        this.$message.success('High-quality PDF generated successfully!');
      } catch (err) {
        console.error('PDF generation failed:', err);
        this.$message.error(`PDF generation failed: ${err.message}`);
      }
    },

    handleImage1Change(file) {
      console.log('Profile photo change:', file);

      if (!file || !file.raw) {
        this.$message.error('Invalid file!');
        return;
      }

      const isLt2M = file.raw.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('Uploaded profile picture size must not exceed 2MB!');
        return;
      }

      try {
        this.cropperImg = URL.createObjectURL(file.raw);
        console.log('Cropper image URL created:', this.cropperImg);
        this.cropperDialogVisible = true;
        console.log('Cropper dialog opened:', this.cropperDialogVisible);
      } catch (error) {
        console.error('Error creating object URL:', error);
        this.$message.error('Failed to load image. Please try again.');
      }
    },

    handleCropDone(croppedData) {
      this.mktSalesCardForm.image1 = croppedData;
    },

    handleCropCancel() {
      console.log('Crop cancelled');
    },

    handleImage2Change(file) {
      const isLt2M = file.raw.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('Uploaded QR code image size must not exceed 2MB!');
        return;
      }

      this.$set(this.mktSalesCardForm, 'image2', URL.createObjectURL(file.raw));
    },
  },
};
</script>

<style scoped>
.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.image {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}
</style>
